import React from 'react';
import '../styles/Footer.css';
import { getImagePath } from '../utils/pathUtils';
import { socialData } from '../data/socialData';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-widget about-widget">
              <div className="footer-logo">
                <img 
                  src={getImagePath('logo-removebg.png')} 
                  alt="Astro Interiors Logo" 
                  className="footer-logo-img"
                />
              </div>
              <p>
                Creating harmonious living spaces with Vastu principles. 
                Your journey to a balanced home starts here.
              </p>
              <div className="social-links">
                {socialData.socialLinks.map((social, index) => {
                  const IconComponent = require('react-icons/fa')[social.icon];
                  if (!IconComponent) {
                    console.warn(`Icon not found for: ${social.name}`);
                    return null; // Don't render anything if the icon is not found
                  }
                  return (
                    <a 
                      key={index}
                      href={social.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="social-link"
                      style={{ '--social-color': social.color }}
                      aria-label={social.name}
                    >
                      <IconComponent className="social-icon" />
                    </a>
                  );
                })}
              </div>
            </div>
            
            <div className="footer-widget">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><a href="/">Home</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/portfolio">Portfolio</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
            
            <div className="footer-widget contact-widget">
              <h4>Contact Info</h4>
              <ul className="contact-info">
                {Object.entries(socialData.contactInfo).map(([key, info]) => {
                  const IconComponent = {
                    phone: FaPhoneAlt,
                    email: FaEnvelope,
                    location: FaMapMarkerAlt
                  }[key];
                  
                  return (
                    <li key={key}>
                      <IconComponent className="contact-icon" />
                      {info.url ? (
                        <a href={info.url} className="contact-link">{info.value}</a>
                      ) : (
                        <span>{info.value}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <p>&copy; {currentYear} Astro Interiors. All Rights Reserved.</p>          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
